module.exports = {
	"2": {
		"0": {
			"73": 2,
			"102": 1,
			"257": 5,
			"307": 5,
			"318": 5,
			"352": 5,
			"403": 1,
			"443": 1,
			"599": 1,
			"743": 1,
			"744": 1
		},
		"1": {
			"21": 2,
			"83": 1,
			"122": 1,
			"129": 1,
			"138": 5,
			"182": 5,
			"195": 5,
			"366": 1,
			"557": 1,
			"607": 1,
			"863": 1,
			"885": 1
		},
		"2": {
			"22": 2,
			"84": 1,
			"123": 1,
			"130": 1,
			"139": 5,
			"183": 5,
			"196": 5,
			"367": 1,
			"558": 1,
			"608": 1,
			"864": 1,
			"886": 1
		},
		"3": {
			"23": 2,
			"85": 1,
			"124": 1,
			"131": 1,
			"140": 5,
			"184": 5,
			"197": 5,
			"368": 1,
			"559": 1,
			"609": 1,
			"865": 1,
			"887": 1
		},
		"4": {
			"24": 2,
			"86": 1,
			"125": 1,
			"132": 1,
			"141": 5,
			"185": 5,
			"198": 5,
			"369": 1,
			"560": 1,
			"610": 1,
			"866": 1,
			"888": 1
		},
		"5": {
			"25": 2,
			"87": 1,
			"126": 1,
			"133": 1,
			"142": 5,
			"186": 5,
			"199": 5,
			"370": 1,
			"561": 1,
			"611": 1,
			"867": 1,
			"889": 1
		},
		"6": {
			"26": 2,
			"88": 1,
			"127": 1,
			"134": 1,
			"143": 5,
			"187": 5,
			"200": 5,
			"371": 1,
			"562": 1,
			"612": 1,
			"868": 1,
			"890": 1
		},
		"7": {
			"27": 2,
			"89": 1,
			"128": 1,
			"135": 1,
			"144": 5,
			"188": 5,
			"201": 5,
			"372": 1,
			"563": 1,
			"613": 1,
			"869": 1,
			"891": 1
		}
	},
	"3": {
		"0": {
			"73": 2,
			"74": 2,
			"102": 1,
			"257": 5,
			"307": 5,
			"318": 5,
			"352": 5,
			"403": 1,
			"443": 1,
			"599": 1,
			"737": 1,
			"882": 1
		},
		"1": {
			"21": 2,
			"83": 1,
			"138": 5,
			"182": 5,
			"195": 5,
			"366": 1,
			"557": 1,
			"607": 1,
			"788": 1,
			"791": 1,
			"842": 1,
			"845": 1,
			"848": 1,
			"896": 1
		},
		"2": {
			"22": 2,
			"84": 1,
			"139": 5,
			"183": 5,
			"196": 5,
			"367": 1,
			"558": 1,
			"608": 1,
			"789": 1,
			"792": 1,
			"843": 1,
			"846": 1,
			"849": 1,
			"897": 1
		},
		"3": {
			"23": 2,
			"85": 1,
			"140": 5,
			"184": 5,
			"197": 5,
			"368": 1,
			"559": 1,
			"609": 1,
			"790": 1,
			"793": 1,
			"844": 1,
			"847": 1,
			"850": 1,
			"898": 1
		},
		"4": {
			"17": 2,
			"176": 5,
			"362": 1
		},
		"5": {
			"13": 2,
			"172": 5,
			"358": 1
		},
		"6": {
			"18": 2,
			"177": 5,
			"363": 1
		},
		"7": {
			"14": 2,
			"173": 5,
			"359": 1
		}
	},
	"4": {
		"0": {
			"73": 2,
			"74": 2,
			"102": 1,
			"137": 5,
			"257": 5,
			"281": 5,
			"307": 5,
			"318": 5,
			"319": 5,
			"320": 5,
			"352": 5,
			"403": 1,
			"443": 1,
			"599": 1,
			"755": 1,
			"798": 1,
			"882": 1,
			"927": 1
		},
		"1": {
			"21": 2,
			"83": 1,
			"138": 5,
			"182": 5,
			"195": 5,
			"366": 1,
			"557": 1,
			"607": 1,
			"836": 1,
			"896": 1,
			"903": 1,
			"909": 1,
			"914": 1,
			"920": 1
		},
		"2": {
			"22": 2,
			"84": 1,
			"139": 5,
			"183": 5,
			"196": 5,
			"367": 1,
			"558": 1,
			"608": 1,
			"837": 1,
			"897": 1,
			"904": 1,
			"910": 1,
			"915": 1,
			"921": 1
		},
		"3": {
			"23": 2,
			"85": 1,
			"140": 5,
			"184": 5,
			"197": 5,
			"368": 1,
			"559": 1,
			"609": 1,
			"838": 1,
			"898": 1,
			"905": 1,
			"911": 1,
			"916": 1,
			"922": 1
		},
		"4": {
			"24": 2,
			"86": 1,
			"141": 5,
			"185": 5,
			"198": 5,
			"369": 1,
			"560": 1,
			"610": 1,
			"839": 1,
			"899": 1,
			"906": 1,
			"912": 1,
			"917": 1,
			"923": 1
		},
		"5": {
			"25": 2,
			"87": 1,
			"142": 5,
			"186": 5,
			"199": 5,
			"370": 1,
			"561": 1,
			"611": 1,
			"840": 1,
			"900": 1,
			"907": 1,
			"913": 1,
			"918": 1,
			"924": 1
		},
		"6": {
			"26": 2,
			"88": 1,
			"143": 5,
			"187": 5,
			"200": 5,
			"371": 1,
			"562": 1,
			"901": 1,
			"908": 1,
			"919": 1,
			"925": 1
		},
		"7": {
			"17": 2,
			"176": 5,
			"362": 1
		},
		"8": {
			"13": 2,
			"172": 5,
			"358": 1
		},
		"9": {
			"18": 2,
			"177": 5,
			"363": 1
		},
		"10": {
			"14": 2,
			"173": 5,
			"359": 1
		},
		"11": {
			"19": 2,
			"178": 5,
			"364": 1
		},
		"12": {
			"15": 2,
			"174": 5,
			"360": 1
		},
		"13": {
			"20": 2,
			"179": 5,
			"365": 1
		},
		"14": {
			"16": 2,
			"175": 5,
			"361": 1
		}
	},
	"5": {
		"0": {
			"349": 5,
			"443": 1,
			"599": 1,
			"689": 1
		}
	},
	"6": {
		"0": {
			"73": 2,
			"82": 2,
			"102": 1,
			"257": 5,
			"296": 5,
			"297": 5,
			"298": 5,
			"299": 5,
			"305": 1,
			"307": 5,
			"308": 5,
			"309": 5,
			"315": 1,
			"318": 5,
			"320": 5,
			"328": 5,
			"329": 5,
			"330": 5,
			"331": 5,
			"332": 5,
			"337": 5,
			"338": 5,
			"339": 5,
			"340": 5,
			"341": 5,
			"342": 5,
			"352": 5,
			"403": 1,
			"427": 1,
			"443": 1,
			"445": 1,
			"505": 1,
			"506": 1,
			"507": 1,
			"513": 3,
			"514": 1,
			"527": 1,
			"534": 1,
			"535": 1,
			"536": 1,
			"537": 1,
			"538": 1,
			"539": 1,
			"540": 1,
			"543": 2,
			"544": 1,
			"550": 1,
			"551": 1,
			"599": 1,
			"623": 1,
			"627": 1,
			"638": 1,
			"687": 1,
			"688": 1,
			"713": 1,
			"732": 1,
			"739": 1,
			"798": 1,
			"894": 1,
			"1861": 6,
			"1870": 3,
			"1871": 3,
			"1872": 1
		},
		"1": {
			"21": 2,
			"76": 2,
			"83": 1,
			"138": 5,
			"182": 5,
			"190": 5,
			"195": 5,
			"300": 5,
			"310": 5,
			"333": 5,
			"366": 1,
			"508": 1,
			"545": 3,
			"552": 1,
			"557": 3,
			"594": 3,
			"618": 1,
			"708": 1,
			"745": 1,
			"750": 1,
			"759": 1,
			"896": 1
		},
		"2": {
			"22": 2,
			"77": 2,
			"84": 1,
			"139": 5,
			"183": 5,
			"191": 5,
			"196": 5,
			"301": 5,
			"311": 5,
			"334": 5,
			"367": 1,
			"509": 1,
			"546": 1,
			"553": 1,
			"558": 3,
			"595": 1,
			"619": 1,
			"709": 1,
			"746": 1,
			"751": 1,
			"760": 1,
			"897": 1
		},
		"3": {
			"23": 2,
			"78": 2,
			"85": 1,
			"140": 5,
			"184": 5,
			"192": 5,
			"197": 5,
			"302": 5,
			"312": 5,
			"335": 5,
			"368": 1,
			"510": 1,
			"547": 1,
			"554": 1,
			"559": 3,
			"596": 1,
			"620": 1,
			"710": 1,
			"747": 1,
			"752": 1,
			"761": 1,
			"898": 1
		},
		"4": {
			"24": 2,
			"79": 2,
			"86": 1,
			"141": 5,
			"185": 5,
			"193": 5,
			"198": 5,
			"303": 5,
			"313": 5,
			"336": 5,
			"369": 1,
			"511": 1,
			"548": 1,
			"555": 1,
			"560": 3,
			"597": 1,
			"621": 1,
			"711": 1,
			"748": 1,
			"753": 1,
			"762": 1,
			"899": 1
		},
		"5": {
			"25": 2,
			"80": 2,
			"87": 1,
			"142": 5,
			"186": 5,
			"194": 5,
			"199": 5,
			"304": 5,
			"314": 5,
			"370": 1,
			"512": 1,
			"549": 1,
			"556": 1,
			"561": 3,
			"598": 1,
			"622": 1,
			"712": 1,
			"749": 1,
			"754": 1,
			"763": 1,
			"900": 1
		}
	},
	"7": {
		"0": {
			"1": 2,
			"74": 2,
			"103": 1,
			"136": 5,
			"137": 5,
			"256": 5,
			"260": 1,
			"261": 1,
			"278": 1,
			"281": 5,
			"282": 5,
			"306": 5,
			"321": 5,
			"322": 5,
			"323": 5,
			"324": 5,
			"325": 5,
			"326": 1,
			"327": 1,
			"343": 5,
			"345": 5,
			"346": 5,
			"349": 5,
			"412": 1,
			"415": 1,
			"416": 1,
			"417": 1,
			"418": 1,
			"425": 1,
			"426": 10,
			"428": 1,
			"429": 1,
			"432": 1,
			"433": 1,
			"434": 1,
			"435": 1,
			"436": 1,
			"437": 1,
			"439": 1,
			"442": 1,
			"443": 1,
			"462": 1,
			"464": 1,
			"465": 3,
			"515": 1,
			"516": 1,
			"517": 1,
			"518": 1,
			"525": 1,
			"526": 10,
			"528": 1,
			"529": 5,
			"530": 5,
			"531": 5,
			"532": 1,
			"533": 1,
			"599": 1,
			"600": 1,
			"605": 3,
			"614": 3,
			"615": 3,
			"616": 3,
			"617": 1,
			"624": 1,
			"625": 1,
			"626": 1,
			"647": 1,
			"689": 1,
			"693": 1,
			"695": 1,
			"696": 3,
			"697": 3,
			"701": 1,
			"705": 1,
			"706": 1,
			"714": 1,
			"715": 3,
			"720": 3,
			"721": 3,
			"722": 3,
			"723": 3,
			"724": 1,
			"725": 1,
			"726": 1,
			"730": 1,
			"738": 7,
			"795": 1,
			"796": 1,
			"841": 1,
			"862": 1,
			"870": 1,
			"871": 1,
			"872": 1,
			"883": 1,
			"895": 1,
			"902": 1,
			"928": 1
		},
		"1": {
			"21": 2,
			"83": 1,
			"138": 5,
			"182": 5,
			"195": 5,
			"273": 5,
			"419": 1,
			"519": 1,
			"648": 1,
			"664": 1,
			"698": 1,
			"727": 1,
			"729": 1,
			"731": 1,
			"734": 1,
			"756": 1,
			"794": 1,
			"860": 1
		},
		"2": {
			"22": 2,
			"84": 1,
			"139": 5,
			"183": 5,
			"196": 5,
			"274": 5,
			"420": 1,
			"520": 1,
			"649": 1,
			"665": 1,
			"699": 1,
			"728": 1,
			"735": 1,
			"757": 1,
			"859": 1,
			"861": 1
		},
		"3": {
			"2": 2,
			"148": 5,
			"154": 5,
			"160": 5,
			"641": 1,
			"652": 1
		},
		"4": {
			"5": 2,
			"149": 5,
			"155": 5,
			"163": 5,
			"642": 1,
			"655": 1
		},
		"5": {
			"7": 2,
			"150": 5,
			"156": 5,
			"165": 5,
			"643": 1,
			"657": 1
		},
		"6": {
			"151": 5,
			"157": 5,
			"166": 5,
			"644": 1,
			"658": 1,
			"930": 2
		},
		"7": {
			"9": 2,
			"152": 5,
			"158": 5,
			"168": 5,
			"645": 1,
			"660": 1
		},
		"8": {
			"12": 2,
			"153": 5,
			"159": 5,
			"171": 5,
			"646": 1,
			"663": 1
		},
		"9": {
			"66": 2,
			"255": 5,
			"354": 5,
			"355": 5,
			"438": 1,
			"680": 1
		},
		"10": {
			"67": 2,
			"258": 5,
			"356": 5,
			"357": 5,
			"681": 1
		},
		"11": {
			"81": 2,
			"353": 5,
			"440": 1,
			"441": 1,
			"690": 1
		},
		"12": {
			"68": 2,
			"259": 5,
			"682": 1
		},
		"13": {
			"69": 2,
			"146": 5,
			"180": 5,
			"262": 5,
			"650": 1,
			"683": 1,
			"694": 1,
			"740": 1
		},
		"14": {
			"70": 2,
			"263": 5,
			"684": 1
		},
		"15": {
			"72": 2,
			"277": 5,
			"686": 1
		},
		"16": {
			"147": 5,
			"181": 5,
			"275": 5,
			"276": 5,
			"741": 1
		}
	},
	"8": {
		"0": {
			"74": 2,
			"103": 1,
			"256": 5,
			"306": 5,
			"349": 5,
			"443": 1,
			"599": 1,
			"647": 1,
			"689": 1
		},
		"1": {
			"195": 5,
			"664": 1
		},
		"2": {
			"196": 5,
			"665": 1
		},
		"3": {
			"197": 5,
			"666": 1
		},
		"4": {
			"198": 5,
			"667": 1
		}
	},
	"9": {
		"0": {
			"74": 2,
			"256": 5,
			"306": 5,
			"349": 5,
			"443": 1,
			"599": 1,
			"647": 1,
			"689": 1
		},
		"1": {
			"195": 5,
			"664": 1
		},
		"2": {
			"196": 5,
			"665": 1
		}
	},
	"10": {
		"0": {
			"1": 2,
			"74": 2,
			"103": 1,
			"256": 5,
			"306": 5,
			"349": 5,
			"403": 1,
			"443": 1,
			"599": 1
		}
	},
	"11": {
		"0": {
			"74": 2,
			"103": 1,
			"256": 5,
			"306": 5,
			"349": 5,
			"403": 1,
			"443": 1,
			"599": 1
		}
	},
	"12": {
		"0": {
			"74": 2,
			"103": 1,
			"256": 5,
			"306": 5,
			"349": 5,
			"443": 1,
			"599": 1,
			"647": 1,
			"689": 1
		}
	},
	"13": {
		"0": {
			"283": 1,
			"284": 1,
			"285": 1,
			"286": 1,
			"287": 1,
			"288": 1,
			"289": 1,
			"290": 1,
			"291": 1,
			"292": 1,
			"293": 1,
			"294": 1,
			"295": 1,
			"316": 1,
			"452": 1,
			"453": 1,
			"454": 1,
			"455": 1,
			"456": 1,
			"457": 1,
			"458": 1,
			"459": 1,
			"460": 1,
			"461": 1
		}
	},
	"14": {
		"0": {
			"443": 1,
			"599": 1
		}
	},
	"15": {
		"0": {
			"443": 1,
			"599": 1
		}
	},
	"16": {
		"0": {
			"443": 1,
			"599": 1
		}
	},
	"17": {
		"0": {
			"348": 5,
			"443": 1,
			"599": 1
		}
	},
	"18": {
		"0": {
			"65": 2,
			"74": 2,
			"253": 5,
			"256": 5,
			"306": 5,
			"349": 5,
			"350": 5,
			"443": 1,
			"599": 1,
			"601": 1,
			"606": 1,
			"647": 1,
			"679": 1,
			"689": 1,
			"742": 1,
			"797": 1,
			"880": 1,
			"884": 1,
			"895": 1
		},
		"1": {
			"21": 2,
			"195": 5,
			"664": 1,
			"698": 1,
			"734": 1
		},
		"2": {
			"22": 2,
			"196": 5,
			"665": 1,
			"699": 1,
			"735": 1
		},
		"3": {
			"23": 2,
			"197": 5,
			"666": 1,
			"700": 1,
			"736": 1
		}
	},
	"19": {
		"0": {
			"74": 2,
			"103": 1,
			"256": 5,
			"306": 5,
			"349": 5,
			"443": 1,
			"599": 1,
			"606": 1,
			"689": 1,
			"714": 1,
			"902": 1
		},
		"1": {
			"21": 2,
			"138": 5,
			"182": 5,
			"195": 5,
			"664": 1,
			"873": 1,
			"875": 1,
			"877": 1
		},
		"2": {
			"22": 2,
			"196": 5,
			"665": 1,
			"874": 1,
			"876": 1,
			"878": 1
		}
	},
	"20": {
		"0": {
			"74": 2,
			"256": 5,
			"306": 5,
			"349": 5,
			"443": 1,
			"599": 1,
			"689": 1
		},
		"1": {
			"21": 2,
			"138": 5,
			"182": 5,
			"195": 5,
			"664": 1,
			"851": 1
		},
		"2": {
			"22": 2,
			"139": 5,
			"183": 5,
			"196": 5,
			"665": 1,
			"852": 1
		},
		"3": {
			"23": 2,
			"140": 5,
			"184": 5,
			"197": 5,
			"666": 1,
			"853": 1
		},
		"4": {
			"24": 2,
			"141": 5,
			"185": 5,
			"198": 5,
			"667": 1,
			"854": 1
		},
		"5": {
			"25": 2,
			"142": 5,
			"186": 5,
			"199": 5,
			"668": 1,
			"855": 1
		},
		"6": {
			"26": 2,
			"143": 5,
			"187": 5,
			"200": 5,
			"669": 1,
			"856": 1
		},
		"7": {
			"27": 2,
			"144": 5,
			"188": 5,
			"201": 5,
			"670": 1,
			"857": 1
		},
		"8": {
			"28": 2,
			"145": 5,
			"189": 5,
			"202": 5,
			"671": 1,
			"858": 1
		}
	},
	"21": {
		"0": {
			"443": 1,
			"599": 1
		}
	},
	"23": {
		"0": {
			"443": 1,
			"599": 1
		}
	},
	"24": {
		"0": {
			"443": 1,
			"599": 1
		}
	},
	"25": {
		"0": {
			"443": 1,
			"599": 1
		}
	},
	"26": {
		"0": {
			"443": 1,
			"599": 1
		}
	},
	"27": {
		"0": {
			"443": 1,
			"599": 1
		}
	},
	"28": {
		"0": {
			"74": 2,
			"103": 1,
			"256": 5,
			"306": 5,
			"349": 5,
			"403": 1,
			"443": 1,
			"599": 1,
			"603": 1,
			"604": 1,
			"606": 1,
			"926": 1
		}
	},
	"29": {
		"0": {
			"74": 2,
			"254": 5,
			"349": 5,
			"403": 1,
			"443": 1,
			"599": 1
		},
		"1": {
			"21": 2,
			"83": 1,
			"195": 5,
			"366": 1,
			"466": 1,
			"557": 1,
			"799": 1
		},
		"2": {
			"22": 2,
			"84": 1,
			"196": 5,
			"367": 1,
			"467": 1,
			"558": 1,
			"800": 1
		},
		"3": {
			"23": 2,
			"85": 1,
			"197": 5,
			"368": 1,
			"468": 1,
			"559": 1,
			"801": 1
		},
		"4": {
			"24": 2,
			"86": 1,
			"198": 5,
			"369": 1,
			"469": 1,
			"560": 1,
			"802": 1
		},
		"5": {
			"25": 2,
			"87": 1,
			"199": 5,
			"370": 1,
			"470": 1,
			"561": 1,
			"803": 1
		},
		"6": {
			"26": 2,
			"88": 1,
			"200": 5,
			"371": 1,
			"471": 1,
			"562": 1,
			"804": 1
		},
		"7": {
			"27": 2,
			"89": 1,
			"201": 5,
			"372": 1,
			"472": 1,
			"563": 1,
			"805": 1
		},
		"8": {
			"28": 2,
			"90": 1,
			"202": 5,
			"373": 1,
			"473": 1,
			"564": 1,
			"806": 1
		},
		"9": {
			"29": 2,
			"91": 1,
			"203": 5,
			"374": 1,
			"474": 1,
			"565": 1,
			"807": 1
		},
		"10": {
			"30": 2,
			"92": 1,
			"204": 5,
			"375": 1,
			"475": 1,
			"566": 1,
			"808": 1
		},
		"11": {
			"31": 2,
			"93": 1,
			"205": 5,
			"376": 1,
			"476": 1,
			"567": 1,
			"809": 1
		},
		"12": {
			"32": 2,
			"94": 1,
			"206": 5,
			"377": 1,
			"477": 1,
			"568": 1,
			"810": 1
		},
		"13": {
			"33": 2,
			"95": 1,
			"207": 5,
			"378": 1,
			"478": 1,
			"569": 1,
			"811": 1
		},
		"14": {
			"34": 2,
			"96": 1,
			"208": 5,
			"379": 1,
			"479": 1,
			"570": 1,
			"812": 1
		},
		"15": {
			"35": 2,
			"97": 1,
			"209": 5,
			"380": 1,
			"480": 1,
			"571": 1,
			"813": 1
		},
		"16": {
			"36": 2,
			"98": 1,
			"210": 5,
			"381": 1,
			"481": 1,
			"572": 1,
			"814": 1
		},
		"17": {
			"37": 2,
			"99": 1,
			"211": 5,
			"382": 1,
			"482": 1,
			"573": 1,
			"815": 1
		},
		"18": {
			"38": 2,
			"100": 1,
			"212": 5,
			"383": 1,
			"483": 1,
			"574": 1,
			"816": 1
		},
		"19": {
			"39": 2,
			"101": 1,
			"213": 5,
			"384": 1,
			"484": 1,
			"575": 1,
			"817": 1
		},
		"20": {
			"40": 2,
			"104": 1,
			"214": 5,
			"385": 1,
			"485": 1,
			"576": 1,
			"818": 1
		},
		"21": {
			"41": 2,
			"105": 1,
			"215": 5,
			"386": 1,
			"486": 1,
			"577": 1,
			"819": 1
		},
		"22": {
			"42": 2,
			"106": 1,
			"216": 5,
			"387": 1,
			"487": 1,
			"578": 1,
			"820": 1
		},
		"23": {
			"43": 2,
			"107": 1,
			"217": 5,
			"388": 1,
			"488": 1,
			"579": 1,
			"821": 1
		},
		"24": {
			"44": 2,
			"108": 1,
			"218": 5,
			"389": 1,
			"489": 1,
			"580": 1,
			"822": 1
		},
		"25": {
			"45": 2,
			"109": 1,
			"219": 5,
			"390": 1,
			"490": 1,
			"581": 1,
			"823": 1
		},
		"26": {
			"46": 2,
			"110": 1,
			"220": 5,
			"391": 1,
			"491": 1,
			"582": 1,
			"824": 1
		},
		"27": {
			"47": 2,
			"111": 1,
			"221": 5,
			"392": 1,
			"492": 1,
			"583": 1,
			"825": 1
		},
		"28": {
			"48": 2,
			"112": 1,
			"222": 5,
			"393": 1,
			"493": 1,
			"584": 1,
			"826": 1
		},
		"29": {
			"49": 2,
			"113": 1,
			"223": 5,
			"394": 1,
			"494": 1,
			"585": 1,
			"827": 1
		},
		"30": {
			"50": 2,
			"114": 1,
			"224": 5,
			"395": 1,
			"495": 1,
			"586": 1,
			"828": 1
		},
		"31": {
			"51": 2,
			"115": 1,
			"225": 5,
			"396": 1,
			"496": 1,
			"587": 1,
			"829": 1
		},
		"32": {
			"52": 2,
			"116": 1,
			"226": 5,
			"397": 1,
			"497": 1,
			"588": 1,
			"830": 1
		},
		"33": {
			"53": 2,
			"117": 1,
			"227": 5,
			"398": 1,
			"498": 1,
			"589": 1,
			"831": 1
		},
		"34": {
			"54": 2,
			"118": 1,
			"228": 5,
			"399": 1,
			"499": 1,
			"590": 1,
			"832": 1
		},
		"35": {
			"55": 2,
			"119": 1,
			"229": 5,
			"400": 1,
			"500": 1,
			"591": 1,
			"833": 1
		},
		"36": {
			"56": 2,
			"120": 1,
			"230": 5,
			"401": 1,
			"501": 1,
			"592": 1,
			"834": 1
		},
		"37": {
			"57": 2,
			"121": 1,
			"231": 5,
			"402": 1,
			"502": 1,
			"593": 1,
			"835": 1
		}
	},
	"30": {
		"0": {
			"74": 2,
			"103": 1,
			"256": 5,
			"279": 5,
			"306": 5,
			"343": 5,
			"344": 5,
			"346": 5,
			"347": 5,
			"349": 5,
			"350": 5,
			"403": 1,
			"412": 1,
			"415": 1,
			"426": 1,
			"443": 1,
			"446": 1,
			"447": 1,
			"448": 1,
			"449": 1,
			"450": 1,
			"451": 1,
			"515": 1,
			"526": 1,
			"599": 1,
			"601": 1,
			"602": 1,
			"606": 1,
			"617": 1,
			"625": 1,
			"628": 1,
			"647": 1,
			"689": 1,
			"697": 1,
			"701": 1,
			"702": 1,
			"703": 1,
			"704": 1,
			"742": 1,
			"880": 1,
			"895": 1,
			"902": 1
		},
		"1": {
			"21": 2,
			"83": 1,
			"138": 5,
			"182": 5,
			"195": 5,
			"664": 1,
			"698": 1,
			"734": 1,
			"756": 1
		},
		"2": {
			"22": 2,
			"84": 1,
			"139": 5,
			"183": 5,
			"196": 5,
			"665": 1,
			"699": 1,
			"735": 1,
			"757": 1
		},
		"3": {
			"23": 2,
			"85": 1,
			"140": 5,
			"184": 5,
			"197": 5,
			"666": 1,
			"700": 1,
			"736": 1,
			"758": 1
		},
		"4": {
			"3": 2,
			"161": 5,
			"653": 1
		},
		"5": {
			"4": 2,
			"162": 5,
			"654": 1
		},
		"6": {
			"6": 2,
			"164": 5,
			"656": 1
		},
		"7": {
			"8": 2,
			"167": 5,
			"659": 1
		},
		"8": {
			"10": 2,
			"169": 5,
			"661": 1
		},
		"9": {
			"11": 2,
			"170": 5,
			"662": 1
		}
	},
	"31": {
		"0": {
			"60": 2,
			"74": 2,
			"103": 1,
			"137": 5,
			"242": 5,
			"243": 5,
			"244": 5,
			"245": 5,
			"247": 5,
			"256": 5,
			"280": 5,
			"281": 5,
			"306": 5,
			"317": 5,
			"349": 5,
			"403": 1,
			"404": 1,
			"407": 1,
			"408": 1,
			"421": 1,
			"422": 1,
			"423": 1,
			"424": 1,
			"443": 1,
			"444": 1,
			"465": 1,
			"521": 1,
			"522": 1,
			"523": 1,
			"524": 1,
			"599": 1,
			"628": 1,
			"637": 1,
			"674": 1,
			"691": 1,
			"764": 1,
			"773": 1,
			"774": 1,
			"779": 1,
			"879": 1,
			"881": 1
		},
		"1": {
			"21": 2,
			"138": 5,
			"182": 5,
			"195": 5,
			"629": 1,
			"633": 1,
			"664": 1,
			"765": 1,
			"769": 1,
			"775": 1
		},
		"2": {
			"22": 2,
			"139": 5,
			"183": 5,
			"196": 5,
			"630": 1,
			"634": 1,
			"665": 1,
			"766": 1,
			"770": 1,
			"776": 1
		},
		"3": {
			"23": 2,
			"140": 5,
			"184": 5,
			"197": 5,
			"631": 1,
			"635": 1,
			"666": 1,
			"767": 1,
			"771": 1,
			"777": 1
		},
		"4": {
			"24": 2,
			"141": 5,
			"185": 5,
			"198": 5,
			"632": 1,
			"636": 1,
			"667": 1,
			"768": 1,
			"772": 1,
			"778": 1
		},
		"5": {
			"62": 2,
			"233": 5,
			"241": 5,
			"248": 5,
			"406": 1,
			"676": 1
		},
		"6": {
			"61": 2,
			"232": 5,
			"240": 5,
			"246": 5,
			"405": 1,
			"675": 1
		},
		"7": {
			"58": 2,
			"234": 5,
			"236": 5,
			"238": 5,
			"672": 1
		},
		"8": {
			"59": 2,
			"235": 5,
			"237": 5,
			"239": 5,
			"673": 1
		}
	},
	"32": {
		"0": {
			"73": 2,
			"102": 1,
			"256": 5,
			"257": 5,
			"306": 5,
			"307": 5,
			"318": 5,
			"352": 5,
			"403": 1,
			"443": 1,
			"599": 1,
			"739": 1
		},
		"1": {
			"21": 2,
			"122": 1,
			"129": 1,
			"138": 5,
			"182": 5,
			"195": 5,
			"366": 1,
			"557": 1,
			"607": 1
		},
		"2": {
			"22": 2,
			"123": 1,
			"130": 1,
			"139": 5,
			"183": 5,
			"196": 5,
			"367": 1,
			"558": 1,
			"608": 1
		},
		"3": {
			"23": 2,
			"124": 1,
			"131": 1,
			"140": 5,
			"184": 5,
			"197": 5,
			"368": 1,
			"559": 1,
			"609": 1
		},
		"4": {
			"17": 2,
			"176": 5,
			"362": 1
		},
		"5": {
			"13": 2,
			"172": 5,
			"358": 1
		},
		"6": {
			"18": 2,
			"177": 5,
			"363": 1
		},
		"7": {
			"14": 2,
			"173": 5,
			"359": 1
		},
		"8": {
			"19": 2,
			"178": 5,
			"364": 1
		},
		"9": {
			"15": 2,
			"174": 5,
			"360": 1
		}
	},
	"33": {
		"0": {
			"348": 5,
			"443": 1,
			"599": 1
		}
	},
	"34": {
		"0": {
			"1": 2,
			"74": 2,
			"103": 1,
			"136": 5,
			"256": 5,
			"260": 1,
			"261": 1,
			"278": 1,
			"282": 5,
			"306": 5,
			"321": 5,
			"322": 5,
			"323": 5,
			"324": 5,
			"325": 5,
			"326": 1,
			"327": 1,
			"343": 5,
			"345": 5,
			"346": 5,
			"349": 5,
			"415": 1,
			"417": 1,
			"418": 1,
			"425": 1,
			"426": 1,
			"443": 1,
			"515": 1,
			"517": 1,
			"518": 1,
			"525": 1,
			"526": 1,
			"528": 1,
			"529": 5,
			"530": 1,
			"531": 1,
			"532": 1,
			"599": 1,
			"647": 1,
			"689": 1,
			"693": 1,
			"696": 1,
			"697": 1,
			"701": 1,
			"715": 1,
			"722": 1,
			"738": 7,
			"862": 1,
			"895": 1,
			"902": 1
		},
		"1": {
			"21": 2,
			"83": 1,
			"138": 5,
			"182": 5,
			"195": 5,
			"419": 1,
			"519": 1,
			"664": 1,
			"698": 1,
			"734": 1,
			"756": 1,
			"794": 1,
			"860": 1
		},
		"2": {
			"22": 2,
			"84": 1,
			"139": 5,
			"183": 5,
			"196": 5,
			"420": 1,
			"520": 1,
			"665": 1,
			"699": 1,
			"735": 1,
			"757": 1,
			"859": 1,
			"861": 1
		},
		"3": {
			"2": 2,
			"148": 5,
			"154": 5,
			"160": 5,
			"652": 1
		},
		"4": {
			"5": 2,
			"149": 5,
			"155": 5,
			"163": 5,
			"655": 1
		},
		"5": {
			"7": 2,
			"150": 5,
			"156": 5,
			"165": 5,
			"657": 1
		},
		"6": {
			"151": 5,
			"157": 5,
			"166": 5,
			"658": 1,
			"930": 2
		},
		"7": {
			"9": 2,
			"152": 5,
			"158": 5,
			"168": 5,
			"660": 1
		},
		"8": {
			"12": 2,
			"153": 5,
			"159": 5,
			"171": 5,
			"663": 1
		},
		"9": {
			"255": 5
		},
		"10": {
			"353": 5
		}
	},
	"35": {
		"0": {
			"74": 2,
			"256": 5,
			"306": 5,
			"349": 5,
			"426": 1,
			"443": 1,
			"526": 1,
			"599": 1,
			"647": 1,
			"689": 1,
			"701": 1,
			"722": 1,
			"733": 1,
			"862": 1,
			"902": 1
		},
		"1": {
			"21": 2,
			"138": 5,
			"182": 5,
			"195": 5,
			"664": 1
		}
	},
	"36": {
		"0": {
			"74": 2,
			"256": 5,
			"306": 5,
			"349": 5,
			"443": 1,
			"599": 1,
			"601": 1,
			"606": 1,
			"647": 1,
			"689": 1
		},
		"1": {
			"21": 2,
			"195": 5,
			"664": 1
		}
	},
	"37": {
		"0": {
			"443": 1,
			"599": 1
		}
	},
	"38": {
		"0": {
			"74": 2,
			"349": 5,
			"403": 1,
			"413": 1,
			"414": 1,
			"443": 1,
			"599": 1
		}
	},
	"39": {
		"0": {
			"403": 1,
			"443": 1,
			"599": 1
		}
	},
	"40": {
		"0": {
			"443": 1,
			"599": 1,
			"647": 1,
			"689": 1
		}
	},
	"41": {
		"0": {
			"74": 2,
			"103": 1,
			"137": 5,
			"251": 5,
			"252": 5,
			"256": 5,
			"281": 5,
			"306": 5,
			"349": 5,
			"403": 1,
			"409": 1,
			"410": 1,
			"411": 1,
			"430": 1,
			"431": 1,
			"628": 1,
			"692": 1,
			"784": 1,
			"787": 1
		},
		"1": {
			"21": 2,
			"138": 5,
			"182": 5,
			"195": 5,
			"639": 1,
			"664": 1,
			"780": 1,
			"782": 1,
			"785": 1
		},
		"2": {
			"22": 2,
			"139": 5,
			"183": 5,
			"196": 5,
			"640": 1,
			"665": 1,
			"781": 1,
			"783": 1,
			"786": 1
		},
		"3": {
			"64": 2,
			"250": 5,
			"678": 1
		},
		"4": {
			"63": 2,
			"249": 5,
			"677": 1
		}
	},
	"42": {
		"0": {
			"74": 2,
			"349": 5,
			"413": 3,
			"414": 1,
			"443": 1,
			"599": 1
		},
		"1": {
			"557": 1,
			"1865": 1
		},
		"2": {
			"558": 1,
			"1866": 1
		},
		"3": {
			"559": 1,
			"1867": 1
		},
		"4": {
			"560": 1,
			"1868": 1
		},
		"5": {
			"561": 1,
			"1869": 1
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/grid-control/providers/slot-families-config.json
// module id = 1826
// module chunks = 2